module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      L. A. Banks\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("L. A. BANKS")]), _vm._v(" is the author of the Vampire Huntress Legend series and the Crimson Moon Novels. She had a bachelor's degree from the University of Pennsylvania's Wharton School of Business and a master's in fine arts from Temple University. Banks considered herself a shape-shifter. She wrote romance, women's fiction, crime and suspense, and of course, dark vampire huntress lore. She lived with her daughter in an undisclosed lair somewhere in Philadelphia.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Br6e1k/tc-custom/9781429931199.jpg?1730580217074",
      "alt": "This image is the cover for the book Darkness, Vampire Huntress Legend Series"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Darkness, Vampire Huntress Legend Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("The Darkness")]), _vm._v(" descends with the arrival of the Armaggedon in the tenth novel of L. A. Banks's bestselling Vampire Huntress Legend series.")]), _c('br'), _c('br'), _vm._v("After the battle at Masada, the Neteru team returns to San Diego believing forty-thousand demons had been eradicated and that Lilith's spawn has been killed. But somehow the treacherous little creature got away. Just as had been prophesized at the dawn of the Armageddon, the anti-Christ has been born and will soon rise to power."), _c('br'), _c('br'), _vm._v("Rewarded for her creation, Lilith is given the daylight bite and power to make Councilmen day-walkers. Having Fallon Nuit and Sebastian able to withstand sunlight is a huge problem, especially when they are adding new master vampires at recordbreaking levels. Meanwhile the dark realms are healing and adding to what had previously been wiped out—feeding off the dark energy of the newly created anti-christ who is only waiting to emerge.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0